import * as React from "react";

// import { useCampaign, useQuestionnaire } from "./utils/CampaignStore";
import {
    AddSet,
    AnswerQuestion,
    DeleteAttachment,
    DeleteComment,
    GetQuestionnaire,
    IQuestionnaireInstance,
    Question,
    Questionnaire,
    RemoveSet,
    SubmitQuestionnaire,
    UnlockQuestionnaire,
} from "../utils/ServiceManagerAPI";

import { Link, useNavigate, useParams } from "react-router-dom";
import AnswerableQuestion from "../components/AnswerableQuestion";
import { useUser } from "../utils/AccountStore";

import SkeletonWrapper from "../components/SkeltonWrapper";
import { Anchor, Box, Button, Heading, Text } from "grommet";

import StyledModal from "../components/StyledModel";
import LinkAnchor from "../components/LinkAnchor";
import { FaChevronLeft } from "react-icons/fa6";
import CommentUpload from "../components/CommentUpload";
import AttachmentUpload from "../components/AttachmentUpload";

export const QuestionnaireContext = React.createContext({} as Questionnaire);

let Questions = () => {
    //@ts-ignore
    let { id } = useParams();

    let [loading, setLoading] = React.useState(true);
    let [submitting, setSubmitting] = React.useState(false);

    let { user } = useUser();

    let navigate = useNavigate();

    const [questions, setQuestions] = React.useState([] as Question[]);
    const [questionnaire, setQuestionnaire] = React.useState({} as Questionnaire);
    const [questionnaireInstance, setQuestionnaireInstance] = React.useState({} as IQuestionnaireInstance);

    React.useEffect(() => {
        //@ts-ignore
        if (id) {
            refreshQuestionnaire();
        }
    }, [id]);

    const refreshQuestionnaire = () => {
        return GetQuestionnaire(id).then((result) => {
            setQuestionnaireInstance(result);
            setQuestionnaire(result.questionnaire);
            setQuestions(result.questionnaire.questions);
            setLoading(false);
        });
    };

    let handleOptionChange = (value, option, questionId, setId?) => {
        setQuestions(
            questions.map((q) => {
                if (q.id == questionId) {
                    if (q.allowSets) {
                        q.sets?.forEach((s) => {
                            if (s.id == setId) {
                                s.options.forEach((o) => {
                                    if (o.id == option.id) {
                                        o.value = value;
                                    } else {
                                        if (o.type == 0 && !q.multipleOptions) {
                                            o.value = false;
                                        }
                                    }
                                });
                            }
                        });
                    } else {
                        q.options?.forEach((o) => {
                            if (o.id == option.id) {
                                o.value = value;
                            } else {
                                if (o.type == 0 && !q.multipleOptions) {
                                    o.value = false;
                                }
                            }
                        });
                    }
                }
                return q;
            })
        );

        return AnswerQuestion(questionnaire.id, questionId, setId, option).then(refreshQuestionnaire);
    };

    let addSet = (questionId) => {
        return AddSet(questionnaire.id, questionId).then((res: any) => {
            setQuestions(
                questions.map((q) => {
                    if (q.id == questionId) {
                        let options = q.options?.map((o) => {
                            let newOption = { ...o };
                            newOption.value = null;
                            return newOption;
                        });

                        res.options = options;
                        q.sets?.push(res);
                    }
                    return q;
                })
            );
            return res;
        });
    };

    let deleteSet = (questionId, setId) => {
        return RemoveSet(setId).then(() => {
            setQuestions(
                questions.map((q) => {
                    if (q.id == questionId) {
                        q.sets = q.sets?.filter((s) => s.id != setId);
                    }
                    return q;
                })
            );
        });
    };

    const commentUploaded = (comment) => {
        toggleCommentModal();
        refreshQuestionnaire();
    };

    let attachmentUploaded = (attachment) => {
        toggleAttachmentModal();
        refreshQuestionnaire();
    };

    let deleteAttachment = (questionId, attachmentId) => {
        DeleteAttachment(attachmentId).then(() => {
            setQuestions(
                questions.map((q) => {
                    if (q.id == questionId) {
                        q.attachments = q.attachments?.filter((a) => a.id != attachmentId);
                    }
                    return q;
                })
            );
        });
    };

    let startSubmit = () => {
        setSubmitting(true);
    };

    let submit = () => {
        SubmitQuestionnaire(questionnaire.id).then(() => {
            setSubmitting(false);
            navigate(`/`);
        });
    };

    const unlock = () => {
        UnlockQuestionnaire(questionnaire.id).then(() => {
            refreshQuestionnaire();
        });
    };

    const save = () => {
        setTimeout(() => {
            navigate("/");
        }, 500);
    };

    const [showCommentModal, setShowCommentModal] = React.useState(false);
    const [showAttachmentModal, setShowAttachmentModal] = React.useState(false);
    const [currentQuestionId, setCurrentQuestionId] = React.useState("");

    const toggleAttachmentModal = (questionId?) => {
        setShowAttachmentModal(!showAttachmentModal);
        setCurrentQuestionId(questionId);
    };

    const toggleCommentModal = (questionId?) => {
        setShowCommentModal(!showCommentModal);
        setCurrentQuestionId(questionId);
    };

    const deleteComment = (questionId, commentId) => {
        return DeleteComment(commentId).then(() => {
            return refreshQuestionnaire();
        });
    };

    return (
        <Box>
            <LinkAnchor
                path="/"
                label={
                    <>
                        <FaChevronLeft />
                        <Text size="large" style={{ marginLeft: "1rem" }}>
                            Home
                        </Text>
                    </>
                }
            ></LinkAnchor>
            <SkeletonWrapper loading={loading}>
                <QuestionnaireContext.Provider value={questionnaire}>
                    <div style={{ minHeight: "100px" }}>
                        {questions.map((question, i) => (
                            <ConditionEvaluator key={i} question={question} questions={questions}>
                                <AnswerableQuestion
                                    currentQuestionnaire={questionnaire}
                                    similarQuestionnaires={[]}
                                    question={question}
                                    handleOptionChange={handleOptionChange}
                                    deleteSet={deleteSet}
                                    addSet={addSet}
                                    toggleAttachmentModal={toggleAttachmentModal}
                                    deleteAttachment={deleteAttachment}
                                    toggleCommentModal={toggleCommentModal}
                                    deleteComment={deleteComment}
                                    loading={loading}
                                    questionnaires={[questionnaireInstance]}
                                ></AnswerableQuestion>
                            </ConditionEvaluator>
                        ))}
                        <Box direction="row" justify="end" pad="small" gap={"small"}>
                            {questionnaire.locked && <Button onClick={unlock} label="Unlock"></Button>}
                            <Button onClick={save} disabled={questionnaire.locked} label="Save"></Button>
                            <Button primary disabled={questionnaire.locked} onClick={startSubmit} label="Complete"></Button>
                        </Box>
                    </div>
                </QuestionnaireContext.Provider>

                <StyledModal isOpen={showCommentModal} setIsOpen={setShowCommentModal}>
                    <Box width={"medium"}>
                        <Heading level="3">Post Comment</Heading>
                        <CommentUpload questionId={currentQuestionId} questionnaireId={questionnaire.id} done={commentUploaded}></CommentUpload>
                    </Box>
                </StyledModal>

                <StyledModal isOpen={showAttachmentModal} setIsOpen={setShowAttachmentModal}>
                    <Box width={"medium"}>
                        <Heading level="3">Post Attachment</Heading>
                        <AttachmentUpload questionId={currentQuestionId} questionnaireId={questionnaire.id} done={attachmentUploaded}></AttachmentUpload>
                    </Box>
                </StyledModal>

                <StyledModal isOpen={submitting} setIsOpen={setSubmitting}>
                    <Text>Are you ready to submit your answers?</Text>
                    <Box direction="row" justify="between" pad="small">
                        <Button label="Cancel" onClick={() => setSubmitting(false)}></Button>
                        <Button primary label="Continue" onClick={submit}></Button>
                    </Box>
                </StyledModal>
            </SkeletonWrapper>
        </Box>
    );
};

function ConditionEvaluator({ question, questions, children }) {
    let show = false;

    if (question.conditions.length > 0) {
        question.conditions.forEach((condition) => {
            let reliesOn = questions.filter((q) => q.id == condition.reliesOnID)[0];

            if (reliesOn) {
                if (condition.type == 1 && reliesOn.answers && reliesOn.answers.length > 0) {
                    let result = false;

                    condition.conditionOptions.forEach((conditionOption) => {
                        reliesOn.options.forEach((option) => {
                            if (option.id == conditionOption.optionID && option.value) {
                                result = true;
                            }
                        });
                    });

                    show = show || result;
                }
            } else {
                show = false;
            }
        });
    } else {
        show = true;
    }

    return <>{show && children}</>;
}

export default Questions;
